import {
  AntimalwareAntiExploitApplicationStatus,
  AntimalwareAntiExploitDetectionTechniques,
  AntimalwareAntiExploitDetectionTechniquesName,
  AntimalwareAntiExploitSystemWideDetectionsLinuxAction,
} from '@nirvana/shared/dtos/types/policies/common';

export function getAntiExploitApplicationStatus(
  isCustomApp: boolean,
  exploitDetectionTechniques: AntimalwareAntiExploitDetectionTechniques[]
): AntimalwareAntiExploitApplicationStatus {
  // status is disabled if it is a custom app
  if (isCustomApp) {
    return AntimalwareAntiExploitApplicationStatus.DISABLE;
  }

  // ignore some detection techniques
  const ignoredDetectionTechniques = [
    AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_WINDOWS_DEP,
    AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_MODULE_RELOCATION,
  ];
  const exploitDetectionTechniquesToCheck = exploitDetectionTechniques.filter(
    technique => !ignoredDetectionTechniques.includes(technique.name)
  );

  // check if all detection techniques are default
  const isDefault = exploitDetectionTechniquesToCheck.every(
    technique =>
      technique.enable && technique.action === AntimalwareAntiExploitSystemWideDetectionsLinuxAction.KILL_PROCESS
  );
  if (isDefault) {
    return AntimalwareAntiExploitApplicationStatus.DEFAULT;
  }

  // check if all detection techniques are disabled
  const isDisabled = exploitDetectionTechniquesToCheck.every(technique => !technique.enable);
  if (isDisabled) {
    return AntimalwareAntiExploitApplicationStatus.DISABLE;
  }

  // otherwise, it is a custom app
  return AntimalwareAntiExploitApplicationStatus.CUSTOM;
}
